import * as Sentry from '@sentry/react';

export const identifySentryUser = (user: {
    _id: string;
    email: string;
    name: string;
}) => {
    Sentry.setUser({
        id: user._id,
        email: user.email,
        name: user.name
    });
    Sentry.setTag('platform', 'web');
    Sentry.setTag('app', 'washday-frontend');
};